import AdminAgencyList from '@/components/Agency/AdminAgencyList'
import AdminAgencyForm from '@/components/Agency/AdminAgencyForm'
import AdminAgencyDetail from '@/components/Agency/AdminAgencyDetail'

let AgencyRouter = [
{
  path: '/admin/agency',
  name: 'AdminAgencyList',
  component: AdminAgencyList,
  meta: {
    requiresAuth: true
  }
}, {
  path: '/admin/agency/new',
  name: 'AdminAgencyNew',
  component: AdminAgencyForm,
  meta: {
    requiresAuth: true
  }
}, {
  path: '/admin/agency/:id/edit',
  name: 'AdminAgencyEdit',
  component: AdminAgencyForm,
  meta: {
    requiresAuth: true
  }
}, {
  path: '/admin/agency/:id',
  name: 'AdminAgencyDetail',
  component: AdminAgencyDetail,
  meta: {
    requiresAuth: true
  }
}]

export default AgencyRouter


// WEBPACK FOOTER //
// ./src/components/Agency/router.js